/**
 * Feature flags for the Access Manager module.
 *
 * Reads from runtime config first (injected via public/index.html at deploy time),
 * then falls back to the CRA build-time environment variable.
 */

/**
 * Returns true only when the Access Manager UI is explicitly enabled.
 *
 * The flag must be the exact string "true" — any other value (including undefined,
 * null, empty string, "1", "yes") is treated as disabled.
 *
 * @returns {boolean}
 */
export function isAccessManagerEnabled() {
  const runtimeValue = window.__RUNTIME_CONFIG__?.ENABLE_ACCESS_MANAGER;
  const value = runtimeValue ?? process.env.REACT_APP_ENABLE_ACCESS_MANAGER;
  return value === "true";
}
